import { mapState, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import { localizeDate } from '@/utils/date';
import { userItemsPerListMixin } from '@/utils/vuex';
import ApiService from '@/services/apiService';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [true],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'CoreCsvExportListScheduled',
  mixins: [userItemsPerListMixin],
  props: {
    search: {
      type: String,
      default: '',
      required: false
    },
    accounts: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  data() {
    return {
      tableOptions: {
        ...defaultTableOptions
      },
      deletePrompt: false,
      runPrompt: false,
      scheduledJobs: [],
      serverItemsLength: -1,
      searchItem: ''
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'language']),
    ...mapGetters({
      getAccountById: 'app/getAccountById',
      sessionUserId: 'authentication/userId'
    }),
    tableHeaders() {
      return [{
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.tableHeaders.active'),
        value: 'active',
        sortable: false
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.tableHeaders.id'),
        value: 'id',
        sortable: true
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.tableHeaders.title'),
        value: 'title',
        sortable: true
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.tableHeaders.account'),
        value: 'tenantId',
        sortable: false
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.tableHeaders.nextTrigger'),
        value: 'nextExecution',
        sortable: false
      }, {
        align: 'end',
        sortable: false,
        value: 'actions'
      }];
    },
    tableFooter() {
      return {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      };
    }
  },
  watch: {
    accounts() {
      this.fetchJobs();
    },
    tableOptions: {
      handler(newVal, oldVal) {
        if (oldVal.itemsPerPage !== newVal.itemsPerPage) {
          this.tableOptions.page = 1;
        }
        this.fetchJobs();
      },
      deep: true
    }
  },
  async mounted() {
    this.fetchJobs();
  },
  methods: {
    localizeDate,
    fetchJobs() {
      const accountIds = this.accounts.map(account => account.id);
      const {
        page,
        itemsPerPage,
        sortBy,
        sortDesc
      } = this.tableOptions;
      const usedPage = page ? page - 1 : 0;
      const usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      ApiService.fetchJobDefinitions(accountIds, usedPage * usedItemsPerPage, usedItemsPerPage, sortBy[0], sortDesc[0]).then(res => {
        this.scheduledJobs = res.JobDefinition;
        this.serverItemsLength = res.totalCount;
      }).catch(() => {
        this.$snack(this.$i18n_t('BackgroundJobs.ScheduledExports.snacks.fetchError'), 'error');
      });
    },
    isIntegrationConfigBroken(item) {
      const emailConfig = item.parameters.emailsData;
      const isEmailBroken = !isEmpty(emailConfig) && !(emailConfig.html && emailConfig.subject && emailConfig.emails && emailConfig.emails.length && emailConfig.bridgeId);
      const thirdPartyConfig = item.parameters.thirdPartyData;
      const isThirdPartyBroken = !isEmpty(thirdPartyConfig) && !(thirdPartyConfig.payload && thirdPartyConfig.bridgeId);
      return isEmailBroken || isThirdPartyBroken;
    },
    tenantIdToName(tenantId) {
      const account = this.getAccountById(tenantId);
      if (!account) {
        return tenantId;
      }
      return account.name;
    },
    handleActiveChange(item, value) {
      ApiService.updateJobDefinition(item.id, value).then(() => {
        this.$snack(this.$i18n_t('BackgroundJobs.ScheduledExports.snacks.updateSuccess'), 'success');
        item.active = value;
      }).catch(() => {
        this.$nextTick(() => {
          this.$snack(this.$i18n_t('BackgroundJobs.ScheduledExports.snacks.updateError'), 'error');
          item.active = !value;
        });
      });
    },
    showDeletePrompt(itemId) {
      ApiService.deleteJobDefinition(itemId).then(() => {
        this.$snack(this.$i18n_t('BackgroundJobs.ScheduledExports.snacks.deleteSuccess'), 'success');
        this.fetchJobs();
        this.deletePrompt = false;
      }).catch(() => {
        this.$snack(this.$i18n_t('BackgroundJobs.ScheduledExports.snacks.deleteError'), 'error');
        this.deletePrompt = false;
      });
    },
    runJob(itemId) {
      ApiService.runJobDefinition(itemId).then(() => {
        this.$snack(this.$i18n_t('BackgroundJobs.ScheduledExports.snacks.runSuccess'), 'success');
      }).catch(() => {
        this.$snack(this.$i18n_t('BackgroundJobs.ScheduledExports.snacks.runError'), 'error');
      }).finally(() => {
        this.runPrompt = false;
      });
    }
  }
};